import React from 'react';
import { Quote, Star } from 'lucide-react';
interface TestimonialProps {
  name: string;
  role: string;
  location: string;
  content: string;
}
export function TestimonialCard({
  name,
  role,
  location,
  content
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-sm border border-blue-100 flex flex-col h-full" data-id="element-12">
      <div className="flex gap-1 mb-4 text-amber-400" data-id="element-13">
        {[1, 2, 3, 4, 5].map(star => <Star key={star} size={16} fill="currentColor" data-id="element-14" />)}
      </div>
      <div className="relative flex-1" data-id="element-15">
        <Quote className="absolute -top-2 -left-2 text-blue-100 w-8 h-8 -z-10" data-id="element-16" />
        <p className="text-gray-700 italic relative z-10 mb-6 text-sm leading-relaxed" data-id="element-17">
          "{content}"
        </p>
      </div>
      <div className="mt-auto pt-4 border-t border-gray-100" data-id="element-18">
        <p className="font-bold text-gray-900" data-id="element-19">{name}</p>
        <p className="text-xs text-blue-600 font-medium" data-id="element-20">{role}</p>
        <p className="text-xs text-gray-500" data-id="element-21">{location}</p>
      </div>
    </div>;
}